import { render, staticRenderFns } from "./CommentUserAvatar.vue?vue&type=template&id=459414fa&"
import script from "./CommentUserAvatar.vue?vue&type=script&lang=js&"
export * from "./CommentUserAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports